<template xmlns="http://www.w3.org/1999/html">
  <div class="news news-content">
    <div
      v-for="one in news"
      class="box"
    >
      <article class="media">
        <div class="media-left">
          <img
            v-if="one.smallpreviewimage"
            :src="one.smallpreviewimage"
          >
          <img
            v-if="!one.smallpreviewimage"
            src="/images/news-1.jpg"
          >
        </div>
        <div class="media-content">
          <div class="content">
            <strong>{{ one.title }}</strong>
            <p v-html="stripeTags(one.text)" />
          </div>
          <nav class="level is-mobile justify-content-end">
            <router-link
              :to="{name: 'News-details', params: {id: one.id, title: one.title.toString().replace(/\?/g,'').toLowerCase().split(' ').join('-'), news: one}}"
              class="button is-small"
            >
              <i class="far fa-arrow-right" />
            </router-link>
          </nav>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NewsList',
    props: ['news'],
    data () {
      return {}
    },
    methods: {
      stripeTags (string) {
        return string.replace(/(<([^>]+)>)/ig, '')
      }
    }
  }
</script>
